__turbopack_context__.v({
  "panelWrapper": "tabItems-module-scss-module__wNdmRG__panelWrapper",
});
